import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import translations from "../../translation"; // Import translations

const ApproversTable = ({ language }) => {
  const translate = (key) => translations[language]?.[key] || key;

  const sampleData = Array.from({ length: 50 }, (_, index) => ({
    name: `User ${index + 1}`,
    email: `user${index + 1}@example.com`,
    mobile: `123-456-789${index % 10}`,
  }));

  const [currentPage, setCurrentPage] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sampleData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sampleData.length / rowsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  const handleView = (user) => {
    setSelectedUser(user);
    setModalShow(true);
  };

  return (
    <div className="bg-white shadow rounded-lg mb-8">
      <div className="px-4 py-5 sm:px-6 flex justify-between items-center">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          {translate("totalApprovers")}
        </h3>
        <div className="flex items-center space-x-3">
          <div className="relative shadow-md">
            <input
              type="text"
              className="form-input pl-10 pr-4 py-2 border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder={translate("searchPlaceholder")}
            />
            <i className="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          </div>
          <button className="bg-black text-white px-4 py-2 rounded-lg shadow-md flex items-center">
            <i className="fas fa-filter mr-2" />
            {translate("filterButton")}
          </button>
        </div>
      </div>
      <div className="border-t border-gray-200">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {translate("name")}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {translate("email")}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {translate("mobileNumber")}
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {translate("actions")}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentRows.map((user, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {user.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {user.email}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {user.mobile}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button
                      onClick={() => handleView(user)}
                      className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-custom hover:text-custom-dark border border-custom rounded-button mr-2"
                    >
                      {translate("viewButton")}
                    </button>
                    <button
                      className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-button mr-2"
                    >
                      {translate("deleteButton")}
                    </button>
                    <button
                      className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-button"
                    >
                      {translate("editButton")}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="d-flex justify-between items-center px-6 py-3 space-x-2">
      <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className={`px-3 py-1.5 text-sm font-medium rounded-lg ${currentPage === 1
              ? "bg-gray-300 text-gray-500"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
        >
          {translate("prevButton")}
        </button>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className={`px-3 py-1.5 text-sm font-medium rounded-lg ${currentPage === totalPages
              ? "bg-gray-300 text-gray-500"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
        >
          {translate("nextButton")}
        </button>
        </div>

      {/* Modal */}
      <Modal
        size="xl"
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
        dialogClassName="modal-75w"
      >
        <Modal.Header closeButton>
          <Modal.Title>{translate("userDetails")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>{translate("field")}</th>
                <th>{translate("value")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{translate("name")}</td>
                <td>{selectedUser?.name || translate("notAvailable")}</td>
              </tr>
              <tr>
                <td>{translate("email")}</td>
                <td>{selectedUser?.email || translate("notAvailable")}</td>
              </tr>
              <tr>
                <td>{translate("mobileNumber")}</td>
                <td>{selectedUser?.mobile || translate("notAvailable")}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ApproversTable;
